import BaseControllerClass from './BaseController';
import ControllerClass from './Controller';
import UniversalControllerClass from './UniversalController';
export function BaseController(options) {
  return new BaseControllerClass(options);
}
export function Controller(options) {
  return new ControllerClass(options);
}
export function UniversalController(options) {
  return new UniversalControllerClass(options);
}
export { default as compute } from './Compute';
export { default as provide } from './Provide';
export { sequence, parallel } from 'function-tree';
export { default as View } from './View';
export { createDummyController, throwError } from './utils';